export function modifyMediaUrl(url) {
    if (typeof url !== "string") return url;
    if (!url.includes(process.env.PORTAL_INSIDE_IP)) return url;

    return changeDomainName(url, process.env.API_ENDPOINT);
}

const changeDomainName = (url, newDomain) => {
    // Remove the protocol (http:// or https://) from newDomain if it exists
    const sanitizedDomain = newDomain.replace(/^https?:\/\//, "");

    const modifiedUrl = url.replace(
        /\/\/([^/:]+)(:\d+)?/,
        (match, oldDomain, port) => `//${sanitizedDomain}`
    );
    // Ensure the URL uses HTTPS protocol
    return modifiedUrl.replace(/^http:/, "https:");
};